import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { BannerSlideImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/bannerSlideImpression.trackingInfo";

import {
    getJsonPayload,
    getPageInfo,
    getUserInfo
} from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: BannerSlideImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<BannerSlideImpressionTrackingInfo> = {
        event: EventType.BannerSlideImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackElement = (element: HTMLElement) => {
    const trackingInfo = getJsonPayload(element);

    track(trackingInfo);
};
